import './bootstrap';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@mayo/mayo-ui-gakki/dist/index.css'

if (
  process.env.NODE_ENV === 'development' &&
  window.location.host.indexOf('localhost') > -1
) {
  const {worker} = require('./mocks/browser');
  worker.start();
}
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
